<div class="sv-question-range-select">
  <div
    class="nd-select nd-select--chip"
    [class.is-open]="isOpen"
    [class.has-selected]="hasSelectedValue"
    [class.is-disabled]="model.isReadOnly"
  >
    <!-- Controllo chip / Trigger -->
    <div
      class="nd-select__control cy-rangeFilter"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="isOpen"
      [attr.aria-disabled]="model.isReadOnly"
      (click)="toggleDropdown($event)"
      (keydown.enter)="toggleDropdown($event)"
      (keydown.space)="toggleDropdown($event)"
    >
      <!-- Valore visualizzato -->
      <div class="nd-select__value">{{ displayText }}</div>

      <!-- Freccia / Chevron -->
      <svg
        viewBox="0 0 24 24"
        class="nd-icon nd-select__arrow"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>

    <!-- Dropdown menu -->
    <div
      *ngIf="isOpen"
      class="nd-select__menu nd-dropdown is-open"
      (click)="$event.stopPropagation()"
    >
      <!-- Container input "Da" e "A" -->
      <div class="InputContainer_container">
        <input
          #minInput
          class="InputContainer_input"
          [class.is-active]="activeField === 'min'"
          inputmode="numeric"
          pattern="[0-9]*"
          type="text"
          [placeholder]="model.minPlaceholder || 'Da'"
          [value]="minInputValue"
          (focus)="setActiveField('min')"
          (input)="onMinInput($event)"
          (keydown.enter)="onConfirm()"
        />
        <input
          #maxInput
          class="InputContainer_input"
          [class.is-active]="activeField === 'max'"
          inputmode="numeric"
          pattern="[0-9]*"
          type="text"
          [placeholder]="model.maxPlaceholder || 'A'"
          [value]="maxInputValue"
          (focus)="setActiveField('max')"
          (input)="onMaxInput($event)"
          (keydown.enter)="onConfirm()"
        />
      </div>

      <!-- Lista scrollabile dei preset -->
      <ul
        class="RangeList_list nd-dropdown__contentScrollable"
        data-cy="range-select-list"
      >
        <li
          class="nd-stackItem"
          [class.is-selected]="isIndifferentSelected"
          (click)="selectIndifferent()"
        >
          Indifferente
        </li>
        <li
          *ngFor="let step of steps"
          class="nd-stackItem"
          [class.is-selected]="isStepSelected(step)"
          (click)="selectStep(step)"
        >
          {{ formatStep(step) }}
        </li>
      </ul>

      <!-- Footer con pulsante di conferma -->
      <div class="nd-select__footer">
        <button
          type="button"
          class="nd-button nd-button--accent nd-button--block"
          data-cy="search-button"
          (click)="onConfirm()"
        >
          {{ model.buttonText || 'Conferma' }}
        </button>
      </div>
    </div>
  </div>
</div>
